export default __webpack_public_path__ + "ca61c7f2f76f139c6c052c5d648ba05e.png";